import React from 'react';
import {
  Box,
  Center,
  Grid,
  Heading,
  SimpleGrid,
} from '@chakra-ui/react';
import ProjectCard from '../components/ProjectCard';
import crypto from '../components/images/Crypto.png';
import Sparta from '../components/images/Sparta.png';
import outlook from '../components/images/outlool.png';


const projects_data = [
   {
     title: "Baby Bliss",
     description: "Baby Bliss is a Kid's clothing website from where you can choose From 5K+ Brands, 2 Lakh+ Products.​",
     imageUrl: "https://user-images.githubusercontent.com/108731705/215068401-d670b38c-3e74-4c47-a2fe-bb4564f704ea.png",
     techstack: "HTML | CSS | JavaScript | React | Next js | Chakra UI ",
     projectUrl: "https://baby-bliss.vercel.app/",
     githubUrl: "https://github.com/RationalPrabal/Baby-Bliss"
   },
  {
    title: "Crypto",
    description: "This is the crypto website build with the help of React js ,Chakra Ui, HTML, CSS , JavaScript , React chart js , and the api is 3rd party so some time it does not work due to many request",
    imageUrl: crypto,
    techstack: "JavaScript | HTML | CSS | React | API | Chakra UI",
    projectUrl: "https://bitcoin-lac.vercel.app/",
    githubUrl: "https://github.com/Deepak1181/Crypto"
  },
  {
    title: "Sparta Fitness Club",
    description: "Sparta Fitness Club is an digital fitness content publisher. The company offers free and paid at-home exercise videos through their website. Sparta Fitness Club offers individual workouts and workout plans.",
    // imageUrl: "https://user-images.githubusercontent.com/107467642/209663552-85268000-6413-438f-8766-ec70f0d0e8ec.png",
    imageUrl: Sparta,
    techstack: "HTML | CSS | JavaScript | React | Chakra UI ",
    projectUrl: "https://gray-system-3325.vercel.app/",
    githubUrl: "https://github.com/Deepak1181/Fitness-Club"
  },
  {
    title: "Kindmeal",
    description: "Customers use our platform to search and discover restaurants, read and write customer generated reviews and view and upload photos, order food delivery, book a table and make payments while dining-out at restaurants.",
    imageUrl: "https://camo.githubusercontent.com/08d6ef0900cbee101fe69e0e0ab9efee85f939867ba7eeb15506b4442899a5ca/68747470733a2f2f692e706f7374696d672e63632f584a30346e7a35792f6b696e646d65616c2e706e67",
    techstack: "HTML | CSS | JavaScript",
    projectUrl: "https://kindmeal-unit-2-project.netlify.app",
    githubUrl: "https://github.com/SunilHooda/kindmeal.my-Clone"
  },
  {
    title: "Outlook",
    description: "Outlook India is most vibrant current affairs and news magazine launched in 1995. It is an insightful, thought-provoking, compelling, in-depth business magazine that delivers a fresh perspective, coupled with a holistic approach.",
    imageUrl: outlook,
    techstack: "HTML, CSS, JavaScript",
    projectUrl: "https://subtle-gaufre-77426e.netlify.app/",
    githubUrl: "https://github.com/PRATEEK9425/OutLook-India"
  },
  // {
  //   title: "Vitural-interiew",
  //   description: "Virtual-interview-app: Master interviews with expert questions, personalized feedback, and model answers for interview perfection.",
  //   imageUrl: AI,
  //   techstack: "HTML | CSS | JavaScript | React | TypeScript | Tailwind | Node.js | Express.js | MongoDB",
  //   projectUrl: "https://virtuval-interview-apk.netlify.app/",
  //   githubUrl: "https://github.com/Neelachari/Vitural-interiew"
  // },
  // {
  //   title: "PharmEasy",
  //   description: "PharmEasy Table of Contents Introduction Navigation Landing Page Sign Page Login Page Conclusion",
  //   imageUrl: pharmacy_clone,
  //   techstack: "HTML | CSS | JavaScript",
  //   projectUrl: "https://tranquil-cupcake-51b85f.netlify.app/",
  //   githubUrl: "https://github.com/Neelachari/PharmEasy"
  // }
 
];

const Project = () => {
  return (
    <Box p={6} id='projects' margin={{base:1,md:5,lg:20}} mt={-5}>
      <Center mb={10}>
        <Heading as="h1" fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}>
          <span color="red">My</span> Projects
        </Heading>
      </Center>
      <SimpleGrid
        columns={{ base: 1, md: 2, lg: 3 }}
        spacing={6}
        justifyContent="center"
        
      >
        {projects_data.map((el, index) => (
          <ProjectCard key={index} {...el} />
        ))}
      </SimpleGrid>
      
    </Box>
  );
};

export default Project;
